import { isNotDefined } from '@sgme/fp';
import { NumberFormatter } from 'components/shared/NumberFormatter/NumberFormatter';
import type { PrecisionProps } from 'components/userPreferences/form/tabs/PrecisionForm.connect';
import { useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import type { DisplayPrecisionKeys } from 'state/userPreferences/userPreferences.model';
import { defaultPrecisions, PRECISIONS } from 'state/userPreferences/userPreferences.model';

import { FlexRowGroup } from './RowGroup';
import { SectionTitle } from './TabForm';

const defaultPrecisionsValues = defaultPrecisions();
export function PrecisionForm({ onPrecisionChanged, ...props }: PrecisionProps) {
  const trackedOnPrecisionChanged = useCallback(
    (k: DisplayPrecisionKeys, value?: number) => {
      logAnalytics.trackEvent('User preferences', `Set ${k} precision`);
      return onPrecisionChanged(k, value ?? defaultPrecisionsValues[k]!);
    },
    [onPrecisionChanged],
  );

  return (
    <>
      <SectionTitle labelKey="userPreferencesForm.precision.label" />
      {PRECISIONS.map(k =>
        isNotDefined(props[k]) ? null : (
          <FlexRowGroup labelKey={`userPreferencesForm.${k}.label`} isFirst key={k}>
            <NumberFormatter
              onBlur={value => trackedOnPrecisionChanged(k, value)}
              value={props[k]}
              e2e={`${k}-precision`}
            />
          </FlexRowGroup>
        ),
      )}
    </>
  );
}
